export const HAS_LAST_CALL_ENABLED = true
